import { render, staticRenderFns } from "./FilesPicker.vue?vue&type=template&id=475c1c8c&scoped=true&"
import script from "./FilesPicker.vue?vue&type=script&lang=js&"
export * from "./FilesPicker.vue?vue&type=script&lang=js&"
import style0 from "./FilesPicker.vue?vue&type=style&index=0&id=475c1c8c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "475c1c8c",
  null
  
)

export default component.exports